import axios from "axios";

export const TOKEN_KEY = "mu_admin_token";

export const authHeaders = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Attach the admin token to every API request, and send the user back to the
// login page if the server says the session is missing or expired.
export function setupAuth() {
  axios.interceptors.request.use((config) => {
    config.headers = { ...config.headers, ...authHeaders() };
    return config;
  });
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const onSharePage = window.location.pathname.startsWith("/report/share/");
      const isLogin = error.config?.url?.endsWith("/auth/login");
      if (error.response?.status === 401 && !onSharePage && !isLogin) {
        localStorage.removeItem(TOKEN_KEY);
        window.location.assign("/login");
      }
      return Promise.reject(error);
    }
  );
}
